module.exports = __webpack_public_path__ + "svg/games-icon.svg?88e296dba32e454e95f6b8aa9c3dc261";